// import { Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react'
// import { useNavigate } from "react-router-dom";

const columns = [
  // { field: 'id', headerName: 'ID', width: 90 },

  {
    field: 'Date',
    headerName: 'Date',
    width: 110,
    editable: true,
  },
  {
    field: 'Amount',
    headerName: 'Remboursement',
    width: 120,
    editable: true,
    valueGetter: (params) => `${params.row.Amount} €`,
  },
  {
    field: 'RestToPay',
    headerName: 'Rester a payer',
    width: 120,
    editable: true,
    valueGetter: (params) => `${params.row.RestToPay} €`,
  },
]

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  // let navigate = useNavigate();
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }

  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      {/* <Typography variant='h5' sx={{ fontWeight: 600, padding: '10px' }}>
         Véhicules ({operations.count})
      </Typography> */}

      <DataGrid
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        // disableSelectionOnClick
        checkboxSelection
        disableSelectionOnClick
        // onRowClick={(e) => navigate(`/domicile/vehicule/${e.row.id}`)}

        // onRowClick={(params, event) => {
        //   if (event.target.localName === 'div') {
        //     // window.open(params.row.Lien)
        //     navigate(`/domicile/vehicule/{}`)
        //   }
        // }}
      />
    </div>
  )
}
export default ListOperations
